module.exports = __webpack_public_path__ + "img/example-3.072572c8.png";